export class Metadados {
    constructor({ slug, palavraChave, permalink, metaDescription, tituloSeo, titulo, autor, altImagem, iconUrl, thumbnailUrl, metaRobots,canonical,breadcrumbs, noindex, nofollow }) {
        this.slug = slug ?? {}
        this.palavraChave = palavraChave ?? ''
        this.tituloSeo = tituloSeo ?? ''
        this.titulo = titulo ?? ''
        this.permalink = permalink ?? ''
        this.altImagem = altImagem ?? ''
        this.thumbnailUrl = thumbnailUrl ?? ''
        this.iconUrl = iconUrl ?? ''
        this.metaDescription = metaDescription ?? ''
        this.autor = autor ?? ''
        this.metaRobots = metaRobots ?? [],
        this.canonical = canonical ?? '',
        this.breadcrumbs = breadcrumbs ?? ''
        this.noindex = noindex ?? ''
        this.nofollow = nofollow ?? ''
        
    }
}